//
//
//
//
//
//
//
//
//
//
//
//
//
//

import displayLoggerComparisonQuery from '~/apollo/queries/product/display-logger-comparison'

export default {
  apollo: {
    displayLoggerComparison: {
      prefetch: true,
      query: displayLoggerComparisonQuery
    }
  }
}
